
export const getMSContext = context => ({
    type: 'GET_MS_CONTEXT',
    payload: { context },
})

export const getLanguage = language => ({
    type: 'GET_LANGUAGE',
    payload: { language },
})